import { useEffect, useState } from "react"
import DOMPurify from "dompurify"
import { marked } from "marked"

type UseMarkdownParserOptions = {
	content: string
	allowedTags?: string[]
	allowedAttributes?: string[]
}

export const useMarkdownParser = ({
	content,
	allowedTags = [
		"b",
		"i",
		"em",
		"strong",
		"a",
		"p",
		"br",
		"ul",
		"ol",
		"li",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"blockquote",
		"code",
		"pre",
		"img",
		"details",
		"summary",
		"table",
		"thead",
		"tbody",
		"tfoot",
		"tr",
		"th",
		"td",
		"caption",
		"col",
		"colgroup",
	],
	allowedAttributes = ["href", "target", "rel", "src", "alt", "title", "width", "height", "loading"],
}: UseMarkdownParserOptions) => {
	const [sanitizedContent, setSanitizedContent] = useState("")

	useEffect(() => {
		const parseContent = async () => {
			try {
				marked.setOptions({
					gfm: true,
					breaks: true,
				})

				const parsedContent = await marked.parse(content)

				const cleaned = DOMPurify.sanitize(parsedContent, {
					ALLOWED_TAGS: allowedTags,
					ALLOWED_ATTR: allowedAttributes,
				})
				setSanitizedContent(cleaned)
			} catch (e) {
				console.error("Error parsing content:", e)
				setSanitizedContent("")
			}
		}

		parseContent()
	}, [content, allowedTags, allowedAttributes])

	return { sanitizedContent }
}
